var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        placement: "bottom-start",
        width: _vm.popWidth,
        trigger: "click",
        "popper-class": "owned-branch-tree"
      },
      model: {
        value: _vm.popVisible,
        callback: function($$v) {
          _vm.popVisible = $$v
        },
        expression: "popVisible"
      }
    },
    [
      _c(
        "element-input",
        {
          ref: "input",
          style: {
            width: _vm.width ? _vm.width + "px" : "",
            minWidth: _vm.minWidth ? _vm.minWidth + "px" : "",
            maxWidth: _vm.maxWidth ? _vm.maxWidth + "px" : ""
          },
          attrs: {
            slot: "reference",
            readonly: "",
            value: _vm.valueLabel,
            title: _vm.valueTip
          },
          slot: "reference"
        },
        [
          _c("i", {
            class: _vm.popVisible ? "el-icon-arrow-up" : "el-icon-arrow-down",
            staticStyle: {
              width: "25px",
              "line-height": "28px",
              "font-size": "14px",
              cursor: "pointer"
            },
            attrs: { slot: "suffix" },
            slot: "suffix"
          })
        ]
      ),
      _c(
        "el-scrollbar",
        { style: { height: _vm.treeHeight } },
        [
          _c("el-tree", {
            ref: "tree",
            attrs: {
              data: _vm.options,
              props: { children: "children", label: "label" },
              "node-key": "value",
              "default-expanded-keys": _vm.defaultExpandedKeys,
              "current-node-key": _vm.value,
              "highlight-current": "",
              "expand-on-click-node": false
            },
            on: { "node-click": _vm.handleNodeClick },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var node = ref.node
                  var data = ref.data
                  return [
                    _c(
                      "span",
                      {
                        style:
                          _vm.selectedNodeKey === data.value
                            ? "color: #1F75D5;font-weight: bold;"
                            : "",
                        attrs: { title: data.tip }
                      },
                      [_vm._v(" " + _vm._s(node.label) + " ")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }